import React, { useState, useEffect } from 'react'
import BootstrapTable from 'react-bootstrap-table-next'
import Paginador, { PaginationProvider } from 'react-bootstrap-table2-paginator'

import { useGlobal } from '../../../stores/useGlobal.js'
import PaginacaoTabela from '../../../utils/paginacaoTabela'
import Alert from '../../Mantine/AlertCard/index.jsx'
import Botao from '../../Mantine/Botao/index.jsx'
import Group from '../../Mantine/Group/index.jsx'
import Modal from '../../Mantine/Modal/index.jsx'

import * as S from './styles.js'

export default function AlertaConfirmacaoAcao({
  onClose,
  onConfirm,
  opened,
  acao,
  parqueTodo,
  linhasSelecionadas = []
}) {
  const { setConfirmacaoAcao } = useGlobal()
  const [paginaAtual, setPaginaAtual] = useState(1)

  const valorLimite = 10

  const totalItens = linhasSelecionadas.length || 0
  const totalPaginas = totalItens > 0 ? Math.ceil(totalItens / valorLimite) : 1
  const contador = (paginaAtual - 1) * valorLimite

  const TableprimaryKey = 'ICCID'
  const acaoLabel = acao?.ds_acao
  const acaoTitle = acao?.ds_acao || 'Atenção'
  const columns = [
    {
      dataField: 'ds_eid',
      text: 'EID'
    },
    {
      dataField: 'ICCID',
      text: 'ICCID'
    },
    {
      dataField: 'CALLERID',
      text: 'Linha'
    },
    {
      dataField: 'OPERADORA',
      text: 'Operadora'
    }
  ]

  const opcoesPaginacao = {
    showTotal: true,
    sizePerPage: valorLimite,
    page: paginaAtual,
    totalSize: totalItens,
    firstPageTitle: 'Primeira',
    lastPageTitle: 'Última',
    nextPageTitle: 'Próxima',
    prePageTitle: 'Anterior',
    custom: true,
    onPageChange: (newPage) => {
      trocarPagina(newPage)
    }
  }

  const trocarPagina = (novaPagina) => {
    if (totalPaginas <= 1) return

    setPaginaAtual(novaPagina)
  }

  useEffect(() => {
    return () => {
      setConfirmacaoAcao({
        open: false,
        parqueTodo: false,
        acaoRedux: null,
        callback: null,
        acao: null
      })
    }
  }, [])

  const getLimiteNaPagina = () =>
    contador + valorLimite <= totalItens ? contador + valorLimite : totalItens

  const mensagemParqueTodo = () => {
    return (
      <S.ModalAlert>
        <p className="modal-alert">
          {acaoLabel ? `A ação "${acaoLabel}"` : 'Esta ação'} não pode ser
          executada em todas as linhas do parque, pois existem{' '}
          <b>dispositivos com tecnologia eSIM</b> que não permitem esta
          operação.
          <br />
          <b>A ação não será executada.</b>
        </p>
        <Group position="center">
          <Botao label="Fechar" variant="outline" onClick={onClose} />
        </Group>
      </S.ModalAlert>
    )
  }

  return (
    <div>
      <Modal
        titulo={acaoTitle}
        width={parqueTodo ? '600px' : '950px'}
        opened={opened}
        close={onClose}
        onConfirm={onConfirm}
        positionTitle="left"
        showActionsModal={!parqueTodo}
      >
        {parqueTodo && mensagemParqueTodo()}
        {!parqueTodo && (
          <S.Container>
            <S.Card>
              <PaginationProvider pagination={Paginador(opcoesPaginacao)}>
                {({ paginationProps, paginationTableProps }) => (
                  <>
                    <S.ContainerTable>
                      <BootstrapTable
                        classes="tabela"
                        condensed
                        keyField={TableprimaryKey}
                        data={linhasSelecionadas}
                        columns={columns}
                        bootstrap4
                        bordered={false}
                        noDataIndication="Nenhuma linha selecionada"
                        {...paginationTableProps}
                      />
                    </S.ContainerTable>

                    <S.ContainerPagination>
                      <S.PaginationDescription className="pagination-description">
                        Mostrando
                        <span className="label-tabela-itens-exibidos">
                          {contador + 1}
                        </span>
                        -
                        <span className="label-tabela-itens-exibidos">
                          {getLimiteNaPagina()}
                        </span>
                        de
                        <span className="label-tabela-itens-exibidos">
                          {totalItens}
                        </span>
                      </S.PaginationDescription>

                      <div className="pagination-table">
                        <PaginacaoTabela
                          preview
                          setPaginaAtual={trocarPagina}
                          totalPaginas={totalPaginas}
                          totalItens={totalItens}
                          valorLimite={valorLimite}
                          paginaAtual={paginaAtual}
                          page={paginationProps.page}
                          onPageChange={paginationProps.onPageChange}
                        />
                      </div>
                    </S.ContainerPagination>
                  </>
                )}
              </PaginationProvider>
            </S.Card>

            <Alert
              type="warning"
              title="Atenção!"
              message={
                <>
                  Algumas linhas selecionadas não podem executar
                  {acaoLabel ? ` a ação "${acaoLabel}"` : ' esta ação'} e serão
                  removidas automaticamente.
                  <br /> <b>Deseja realmente prosseguir?</b>
                </>
              }
            />
          </S.Container>
        )}
      </Modal>
    </div>
  )
}
